// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"559":"game-detail-page","567":"main-layout"}[chunkId] + "." + {"559":"0fa3149a","567":"1437bdc0"}[chunkId] + ".css";
};